import { useEffect } from "react";
// mine
import UI from "@/app/lib/ui/ui";
import { InternalRouter } from "@/app/lib/routing/internal-router";
import { GameManager } from "@/app/lib/game-state/game-manager";


// Checks if we need to run the tutorial or not.
export function useTutorialCheck(gameManager: GameManager, ui: UI) {
    // CHECK FOR THE PYRAMID PUZZLE
    useEffect(() => {
        if (ui.path !== '/')
            return;

        if (!ui.isLoaded.pyramid)
            return;

        if (!ui.userHistory.hasVisited.pyramid) {
            const iRouter = new InternalRouter(gameManager, ui);
            iRouter.goPath('/tutorial');
            ui.logVisit('pyramid');
        }
    }, [ui.isLoaded.pyramid, ui.path]);

    // CHECK FOR STORY
    useEffect(() => {
        if (!(ui.path.startsWith('/story')))
            return;

        if (!ui.userHistory.hasVisited.story) {
            const iRouter = new InternalRouter(gameManager, ui);
            iRouter.goPath('/story/tutorial');
            ui.logVisit('story');
        }
    }, [ui.path])
}